import type { ShopexpertsService, ShopexpertsFreelancerProfile } from "@shopexperts/shared";

export function getSlug(profile: Partial<ShopexpertsService["profile"]>): string {
    if (!profile) return '';
    return profile.slug || ('agency_name' in profile ? 'agency_' + profile.agency_name : ((profile as ShopexpertsFreelancerProfile).first_name! + '-' + (profile as ShopexpertsFreelancerProfile).last_name!));
}

export function generateStorySlug(title: string): string {
    return title.toLowerCase().replace(/ /g, '_').replace(/[^a-z0-9_]/g, '');
}

